import { render, staticRenderFns } from "./UploadPixDetail.vue?vue&type=template&id=2f771716&scoped=true&"
import script from "./UploadPixDetail.vue?vue&type=script&lang=js&"
export * from "./UploadPixDetail.vue?vue&type=script&lang=js&"
import style0 from "./UploadPixDetail.vue?vue&type=style&index=0&id=2f771716&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f771716",
  null
  
)

export default component.exports